import React from 'react';
import Tooltip from '@/components/ui/Tooltip';
import cn from '@/utils/cn';
import { sanitizeInlineHtml } from '@/utils/sanitizeInlineHtml';

interface IAssignmentDrawerTitleProps {
  title: string;
}

export function AssignmentDrawerTitle({ title }: IAssignmentDrawerTitleProps) {
  return (
    <Tooltip.Provider>
      <Tooltip>
        <Tooltip.Portal>
          <Tooltip.Content
            className="tw-z-9999 tw-text-left"
            theme="white"
          >
            <span dangerouslySetInnerHTML={{ __html: `${sanitizeInlineHtml(title)} Progress` }} />
            <Tooltip.Arrow />
          </Tooltip.Content>
        </Tooltip.Portal>
        <Tooltip.Trigger asChild>
          <div
            className={cn(
              'tw-border-r-2 tw-border-med-grey tw-border-solid tw-py-1 tw-pr-4 tw-box-border',
              'tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis',
            )}
          >
            <span dangerouslySetInnerHTML={{ __html: `${sanitizeInlineHtml(title)} Progress` }} />
          </div>
        </Tooltip.Trigger>
      </Tooltip>
    </Tooltip.Provider>
  );
}
